import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Radio, ArrowRight, X } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { AIOT_PATH } from "@/lib/aiot";

// Shown to guests and demo users right after they finish a sample recording.
export const EnrollNudge = ({ onClose }) => {
  const { L } = useLang();
  return (
    <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}
      className="mt-5 relative rounded-3xl bg-[#0B1F3A] text-white p-6 sm:p-8 flex flex-wrap items-center gap-5" data-testid="enroll-nudge">
      <button type="button" onClick={onClose} aria-label="Close" className="absolute top-3 right-3 w-8 h-8 rounded-full grid place-items-center text-slate-400 hover:text-white hover:bg-white/10 transition-colors" data-testid="enroll-nudge-close"><X className="w-4 h-4" /></button>
      <span className="w-12 h-12 rounded-2xl bg-[#14B8A6]/20 grid place-items-center shrink-0"><Radio className="w-6 h-6 text-[#5EEAD4]" /></span>
      <div className="flex-1 min-w-[220px]">
        <p className="text-xl font-extrabold" data-testid="enroll-nudge-title">{L("Enjoyed this? Enroll for live classes", "पसंद आया? लाइव क्लास के लिए एनरोल करें")}</p>
        <p className="mt-1 text-sm text-slate-300">{L("Enrolled students learn live with Simran Ma'am, ask questions in class and get all 78 recorded classes, 3D labs and tests.",
          "एनरोल्ड छात्र सिमरन मैम के साथ लाइव सीखते हैं, क्लास में सवाल पूछते हैं और सभी 78 रिकॉर्डेड क्लास, 3D लैब और टेस्ट पाते हैं।")}</p>
      </div>
      <Link to={`${AIOT_PATH}#apply`} className="rounded-full bg-[#14B8A6] text-[#0B1F3A] px-6 h-12 inline-flex items-center gap-2 font-black hover:bg-white transition-colors" data-testid="enroll-nudge-cta">{L("Enroll now", "अभी एनरोल करें")}<ArrowRight className="w-4 h-4" /></Link>
    </motion.div>
  );
};
